var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "path-1-pending",
    x: 4,
    y: 2,
    width: 1280,
    height: 430
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.5%",
    y: "-1.2%",
    width: "101.1%",
    height: "103.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "053---info-hint-Pending-Sync-Status-Card-View",
    transform: "translate(-707.000000, -314.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "card---initial-copy",
    transform: "translate(315.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1-pending"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1-pending"
  })), /*#__PURE__*/React.createElement("g", {
    id: "white-card",
    transform: "translate(392.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "status",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sand-Clock"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(6.136364, 4.909091)",
    fill: "#636363",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06363636,1.0828877 L1.06363636,2.58449198 L2.63863636,2.58449198 L2.63863636,5.14773048 L6.24971761,8.59090909 L2.63863636,12.0340877 L2.63863636,14.5973262 L1.06363636,14.5973262 L1.06363636,16.0989305 L13.6636364,16.0989305 L13.6636364,14.5973262 L12.0886364,14.5973262 L12.0886364,12.0340877 L8.47716136,8.59090909 L12.0886364,5.14773048 L12.0886364,2.58449198 L13.6636364,2.58449198 L13.6636364,1.0828877 L1.06363636,1.0828877 Z M3.97132867,4.04946157 L3.97132867,2.08395722 L10.7559441,2.08395722 L10.7559441,4.04946157 L7.36363636,7.08930481 L3.97132867,4.04946157 Z M3.97132867,13.1325058 L7.36363636,10.0925134 L10.7559441,13.1325058 L10.7559441,15.097861 L3.97132867,15.097861 L3.97132867,13.1325058 Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#636363",
    strokeWidth: 1.5,
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.685c6b730730938f965f8a401161996a.svg";
export { ForwardRef as ReactComponent };